import { cn } from "@/shadcn/lib/utils";
import { colorIsDarkAdvanced } from "@/utils/utils";
import React from "react";

type TagProps = {
  id: string | number;
  color: string;
  name: string;
  full: boolean;
  className?: string;
};

const SingleTag: React.FC<TagProps> = ({
  id,
  color,
  name,
  full,
  className,
}) => {
  return (
    <div
      key={id}
      className={cn(
        `px-2 pb-1 rounded ${
          full ? "w-fit" : "max-w-24 truncate"
        }  h-7 leading-7`,
        className
      )}
      style={{
        backgroundColor: color,
        color: colorIsDarkAdvanced(color) ? "white" : "black",
      }}
    >
      {name}
    </div>
  );
};

export default SingleTag;
